// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // Appended to URLs the build copies verbatim, so a new release fetches them
  // instead of reusing a cached copy. Those filenames never change on their own
  // - unlike the content-hashed bundles - so without this a corrected
  // translation is invisible to anyone who already loaded the old one.
  //
  // BUMP THIS whenever a file under src/assets changes.
  appVersion: '1.2.0'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
